jQuery($ => {
  class Umktg_Gate {
    constructor(element) {
      this._        = element;
      this._element = $(element);

      this._trigger = $('a[href*="?gate"], a[href*="&gate"]').filter(function() {
        const href      = $(this).attr('href');
        const gateParam = new URLSearchParams(href.split('?')[1]).get('gate');

        return gateParam !== 'false' && gateParam !== false;
      });
      
      this._modalId = this._element.attr('id');
      this._triggerId;
      this._triggerHref;
      this._triggerTarget;
      this._triggerDownload;
      this._ajax = this._element.data('ajax');

      this._gateId = this._element.data('gate');
      this._storageKey = `umktg.gate.${this._gateId}.unlocked`;

      this._openTrigger     = this._element.data('open-trigger');
      this._openTargetType  = this._element.data('open-target-type');
      this._openTargetValue = this._element.data('open-target-value');

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger( 'init', this );

      if (localStorage.getItem(this._storageKey) === 'true') {
        this.unlockContent();
      } else {
        if ($('body').hasClass('gated')) {
          if (this._openTrigger === 'load') {
            $(window).on('resize', () => this.lockContent());
            this.handleOpenOnLoad();
          } else if (this._openTrigger === 'scroll') {
            $(window).on('scroll', () => this.handleOpenOnScroll());
          }
        }
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      $(window).on('load', this.handleWindowLoad);

      this._element.on('unlock', (event, triggerClickEvent) => this.handleUnlock(triggerClickEvent));
      this._element.on('attemptUnlock', this.handleUnlockAttempt);

      this._trigger.each((_, trigger) => {
        $(trigger).on('mousedown', event => {
          this.handleTriggerClick(event)
        });
        $(trigger).on('keydown', event => {
          this.handleTriggerKeydown(event)
        });
      });

      this._element.on('click', '.close-gate, [href*="#close-gate"]', (event) => this.handleCloseGate(event));
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Lock Content
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    lockContent() {
      if ($('body').hasClass('gated')) {
        $('body, main').css({
          overflow: 'hidden',
          height: '100vh',
          width: '100%'
        });
        
        $('main ~ :not(script):not(.umktg-gate)').css({
          zIndex: '0'
        });
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Unlock Content
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    unlockContent() {
      $('body, main').css({
        overflow: '',
        height: '',
        width: ''
      });

      $('main ~ :not(script):not(.umktg-gate)').css({
        zIndex: ''
      });

      $('body').removeClass('gated');
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Check Is Unlocked
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    checkIsUnlocked() {
      return localStorage.getItem(this._storageKey) ? true : false;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Check If Trigger Is Released
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    checkIsTriggerReleased = trigger => {
      const $trigger   = $(trigger);
      const isReleased = $trigger.hasClass('--released');

      return isReleased;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Check If Trigger Is Unlocked
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    checkIsTriggerUnlocked = trigger => {
      if (!this.checkIsUnlocked()) return;
      return this.checkIsTriggerReleased($(trigger));
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Window Load
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleWindowLoad = () => {
      if (this.checkIsUnlocked()) {
        this.releaseTriggers();
      } else {
        this.setTriggerAttrs();
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Set Trigger Aria Controls
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setTriggerAttrs = () => {
      this._trigger.each((_, trigger) => {
        if (this._modalId !== undefined) {
          $(trigger).attr('aria-controls', this._modalId);
        }

        if (!$(trigger).attr('id')) {
          const uid       = String(Math.floor(Math.random() * 100000)).padStart(5, '0');
          const triggerId = `gateTrigger-${uid}`;

          $(trigger).attr('id', triggerId);
        }
      });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Set Local Storage
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setLocalStorage = (setToUnlocked = true) => {
      localStorage.setItem(this._storageKey, setToUnlocked);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Release Triggers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    releaseTriggers = () => {
      this._trigger.each((_, trigger) => {
        $(trigger).addClass('--released');
      });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Trigger Mousedown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleTriggerClick = event => {
      if (this.checkIsTriggerUnlocked(event.currentTarget)) return;

      event.preventDefault();

      const $trigger = $(event.currentTarget);

      this._triggerId       = $trigger.attr('id');
      this._triggerHref     = $trigger.attr('href');
      this._triggerTarget   = $trigger.attr('target');
      this._triggerDownload = $trigger.is('[download]');

      this.handleModalToggle();

      this._element.trigger('openGate', {
        id       : this._triggerId,
        href     : this._triggerHref,
        target   : this._triggerTarget,
        download : this._triggerDownload
      });
    }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Handle Trigger Keydown
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  handleTriggerKeydown = event => {
    switch (event.key) {
      case 'Enter':
      case 'spacebar':
      case ' ':
        if (this.checkIsTriggerUnlocked(event.currentTarget)) return;

        event.preventDefault();

        const $trigger = $(event.currentTarget);

        this._triggerId       = $trigger.attr('id');
        this._triggerHref     = $trigger.attr('href');
        this._triggerTarget   = $trigger.attr('target');
        this._triggerDownload = $trigger.is('[download]');

        this.handleModalToggle();

        this._element.trigger('openGate', {
          id       : this._triggerId,
          href     : this._triggerHref,
          target   : this._triggerTarget,
          download : this._triggerDownload
        });
        break;
    }
  }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Modal Open
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleModalOpen = event => {
      $('.umktg-modal--open, .m-modal--open').each(function() {
        if ($(this).hasClass('umktg-modal--open')) {
          $(this).umktg_modal('handleClose');
        } else {
          $(this).modal('handleClose');
        }
      });

      if (this._element.hasClass('umktg-modal')) {
        this._element.umktg_modal('setControlledby', this._triggerId);
        this._element.umktg_modal('handleOpen', true);
      } else {
        this._element.modal('setControlledby', this._triggerId);
        this._element.modal('handleOpen');
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Modal Close
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleModalClose = () => {
      if (this._element.hasClass('umktg-modal')) {
        this._element.umktg_modal('handleClose');
      } else {
        this._element.modal('handleClose');
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Modal Toggle
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleModalToggle = () => {
      if (
        this._element.hasClass('umktg-modal--open')
        || this._element.hasClass('m-modal--open')
      ) {
        this.handleModalClose();
      } else {
        this.handleModalOpen();
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Gate Close
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleCloseGate = (event) => {
      event.preventDefault();

      if (!this.checkIsUnlocked()) return;

      this.handleModalClose();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Unlock
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleUnlock = (triggerClickEvent = false) => {
      this.setLocalStorage();
      this.releaseTriggers();

      if (triggerClickEvent) {
        $(`#${this._triggerId}`)[0].click();
      }

      if ($('body').hasClass('gated')) {
        this.unlockContent();
        setTimeout(() => this._element.removeClass('umktg-modal--open, m-modal--open'), 800);
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Unlock Attempt
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleUnlockAttempt = (_, formData) => {
      const isUnlocked = this.checkIsUnlocked();

      if (!isUnlocked) {
        let data = {
          action: 'umktg_unlock_gate',
          data: {
            gateId: this._modalId,
            trigger: {
              url      : this._triggerHref,
              target   : this._triggerTarget,
              download : this._triggerDownload
            },
            form: formData
          }
        }

        $.ajax({
          url: this._ajax,
          type: 'POST',
          data,
          success: this.handleResponse.bind(this)
        });
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Response
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleResponse = response => {
      const isSuccess = response.success === undefined || response.success;
      const data      = response.data || {};

      if (isSuccess) {
        this.handleRequestSuccess(data);
      } else {
        this.handleRequestError(data);
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Request Success
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleRequestSuccess = data => {
      this._element.find('.umktg-modal__content, .m-modal__content').html(data);
      this.handleUnlock(true);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Request Error
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleRequestError = data => {
      console.error('Status: Filter ajax request failed', data);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Open On Page Load
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleOpenOnLoad = () => {
      setTimeout(() => {
        this._element.umktg_modal('handleOpen', true);
        this.lockContent();
      }, 1000);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Open On Scroll Distance (px)
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    openOnPxScroll = () => {
      const openPosition = parseInt(this._openTargetValue);
      const scrollPosition = $(window).scrollTop();

      if (scrollPosition >= openPosition) {
        this._element.umktg_modal('handleOpen', true);
        this.lockContent();
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Open On Scroll Distance (%)
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    openOnPercentScroll = () => {
      const openPercent          = parseInt(this._openTargetValue);
      const scrollPosition   = $(window).scrollTop();
      const windowHeight     = $(window).height();
      const documentHeight   = $(document).height();
      const scrollPercentage = (scrollPosition / (documentHeight - windowHeight)) * 100;

      if (scrollPercentage >= openPercent) {
        this._element.umktg_modal('handleOpen', true);
        this.lockContent();
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Open On Scroll To Selector
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    openOnSelectorScroll = () => {
      const selector         = this._openTargetValue;
      const offset           = 20;
      const selectorPosition = $(selector).offset().top + offset;
      const scrollPosition   = $(window).scrollTop();
      const windowHeight     = $(window).height();
      const windowBottom     = scrollPosition + windowHeight;

      if (windowBottom >= selectorPosition) {
        this._element.umktg_modal('handleOpen', true);
        this.lockContent();
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Open On Scroll
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleOpenOnScroll = () => {
      const scrollToType = this._openTargetType;

      if (scrollToType === 'px') {
        this.openOnPxScroll();
      } else if (scrollToType === 'percent') {
        this.openOnPercentScroll();
      } else if (scrollToType === 'selector') {
        this.openOnSelectorScroll();
      }
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.umktg_gate = function() {
    var _ = this,
        opt = arguments[0],
        args = Array.prototype.slice.call(arguments, 1),
        l = _.length,
        i,
        ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].umktg_gate = new Umktg_Gate(_[i], opt);
      else
        ret = _[i].umktg_gate[opt].apply(_[i].umktg_gate, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.umktg-gate').umktg_gate();
});